export default __webpack_public_path__ + "static/workflowAutomationBg1-439fe61e00c7685ce4d1a13aa2ae62fe.png";